import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Calendar14: FC<IconProps> = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M9 3.38h6v-1.5h1.5v1.5h2.02A2.5 2.5 0 0 1 21 5.8v13.88a2.43 2.43 0 0 1-2.48 2.45H5.48A2.44 2.44 0 0 1 3 19.68V5.8a2.5 2.5 0 0 1 2.45-2.42H7.5v-1.5H9zm-4.5 16.3c0 .54.42.94.98.95h13.04c.56 0 .98-.41.98-.95v-9.55h-15zM9.95 18h1.11v1.29H7.35v-1.3h1.08v-5.24h-.95v-1.31h2.47zm6-1.63h.7v1.36h-.7v1.56H14.5v-1.56H11.5V17l2.8-5.56h1.66zm-2.7.06h1.36v-1.5l.08-1.62zM5.48 4.88c-.54.01-.98.42-.98.92v2.83h15V5.8c0-.5-.44-.9-1-.92h-2v1.5H15v-1.5H9v1.5H7.5v-1.5z"
    />
  </Icon>
);
